<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <h3>{{ "i18n.base.set-password.header" | translate }}</h3>
    <form [formGroup]="setPasswordForm" *ngIf="areParametersValid && !passwordSetSuccess">
      <div class="form-group">
        <label for="password">{{ "i18n.base.set-password.password" | translate }}</label>
        <input id="password" type="password" class="form-control" formControlName="password" appRequired
          appPasswordVisibility>
        <app-error-messages [control]="formFields.password"></app-error-messages>
      </div>
      <div class="form-group">
        <label for="passwordConfirm">{{ "i18n.base.set-password.passwordConfirm" | translate }}</label>
        <input id="passwordConfirm" type="password" class="form-control" formControlName="passwordConfirm" appRequired
          appPasswordVisibility>
        <app-error-messages [control]="formFields.passwordConfirm"></app-error-messages>
      </div>
      <button type="submit" class="btn btn-primary" (click)="setPassword()" [disabled]="!setPasswordForm.valid">
        {{ "i18n.base.set-password.setPassword" | translate }}
      </button>
    </form>
    <div *ngIf="!areParametersValid">
      {{ "i18n.base.set-password.invalid-link" | translate }}
    </div>
    <div *ngIf="passwordSetSuccess">
      <div>
        <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.set-password.success-message"
          |
          translate }}</p>
        <p class="success-message" *ngIf="!isMobileUser">{{autoRedirectMessage}}</p>
        <a [routerLink]="[loginRoute]" *ngIf="!isMobileUser">{{ 'i18n.core.navigation.login' | translate }}</a>
      </div>
    </div>
  </div>
